import { useState, forwardRef, InputHTMLAttributes } from 'react'
import Avatar from 'react-avatar'

import './style.scss'
import { EDocumentType } from '../../models'
import { Button } from '../UI'
import documentDefaultImg from '../../assets/img/passport.svg'
import documentBackDefaulImg from '../../assets/img/document-back.svg'
import photoPassportDefaulImg from '../../assets/img/photo-passport.svg'

interface RegisterFormDocumentProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string,
  id: string,
  text?: string,
  docType?: number,
  defaultFile?: string,
  side?: 'FRONT' | 'BACK',
  validate?: boolean,
  onChange?(event: any): void
}

type Ref = HTMLInputElement;

const RegisterFormDocument = forwardRef<Ref, RegisterFormDocumentProps>(({ className = '', id, text = 'CARGAR ESCANEO DEL DOCUMENTO', docType = 1, defaultFile = '', side = 'FRONT', validate = false, onChange, ...rest }, ref)  => {
  const [documentImg, setDocumentImg] = useState<string>('')

  const getImage = () => {
    if(documentImg) return documentImg
    else if(side === 'BACK' && docType === EDocumentType.rut) {
      if(defaultFile) return defaultFile
      else return documentBackDefaulImg
    } else if(side === 'BACK' && docType === EDocumentType.passport) {
      if(defaultFile) return defaultFile
      else return photoPassportDefaulImg
    } else if(defaultFile) return defaultFile
    else return documentDefaultImg
  }

  const getBtnText = () => {
    if(validate) return 'ABRIR'
    if(side === 'BACK' && docType === EDocumentType.passport) return 'CARGAR FOTOGRAFÍA'
    return text
  }

  const onFileChange = (event: any) => {
    const { target: { name, files } } = event

    if(files && files[0]) {
      const fieldName = name
      const fileType = files[0].type
      const fileSize = files[0].size

      if(!(fileType && (fileType.indexOf('png') === -1 && fileType.indexOf('jpeg') === -1)) && !(fileSize && (fileSize / 1024 > 500)) && fieldName === name) {
        const fileImage = URL.createObjectURL(files[0])
        setDocumentImg(fileImage)
      }

      if(onChange) onChange(event)
    }
  }

  const onBtnFileClick = (id: string) => {
    const inputFile = document.getElementById(id)

    if(inputFile) inputFile.click()
  }

  return (
    <div className={`text-center ${className}`}>
      <Avatar
        src={getImage()}
        size="209"
        className="register-form-passport-avatar_img"
      />

      <div className="mt-20">
        <div className="register-passport-file-btn">
          <Button type="button" size="md" borderRadius="4px" fullWidth onClick={(event) => validate ?
              (onChange ? onChange(event) : undefined)
            :
              onBtnFileClick(id)
          }
          >{getBtnText()}</Button>
          <input
            ref={ref}
            type="file"
            id={id}
            accept="image/x-png,image/jpeg"
            onChange={onFileChange}
            {...rest}
          />
        </div>
      </div>
    </div>
  )
})

export { RegisterFormDocument }